import { MessageCircle, Phone } from "lucide-react";
import { useStore } from "../context/StoreContext";

// Renders a WhatsApp CTA when a WhatsApp number is configured in Admin → Settings,
// otherwise falls back to a Call button using the primary phone number.
export const WaButton = ({ label = "WhatsApp Us", fallbackLabel = "Call Us", msg, className = "", testId, iconClass = "h-4 w-4" }) => {
  const { wa, contact } = useStore();
  const isWa = Boolean(wa);
  const Icon = isWa ? MessageCircle : Phone;
  const cls = isWa
    ? className
    : className
        .replaceAll("bg-[#25D366]", "bg-brand-red")
        .replaceAll("text-[#0b3d20]", "text-brand-cream")
        .replaceAll("shadow-[#25D366]/25", "shadow-brand-red/25")
        .replaceAll("shadow-[#25D366]/30", "shadow-brand-red/30")
        .replaceAll("hover:border-[#25D366]", "hover:border-brand-gold")
        .replaceAll("hover:text-[#25D366]", "hover:text-brand-gold");
  return (
    <a
      data-testid={testId}
      href={isWa ? wa(msg) : contact.phoneHref}
      target={isWa ? "_blank" : undefined}
      rel={isWa ? "noreferrer" : undefined}
      className={cls}
    >
      <Icon className={iconClass} /> {isWa ? label : fallbackLabel}
    </a>
  );
};
